import { initializerDefineProperty as _initializerDefineProperty } from "\0rollupPluginModLoBabelHelpers.js";
import { assertThisInitialized as _assertThisInitialized } from "\0rollupPluginModLoBabelHelpers.js";
import { inheritsLoose as _inheritsLoose } from "\0rollupPluginModLoBabelHelpers.js";
import { defineProperty as _defineProperty } from "\0rollupPluginModLoBabelHelpers.js";
import { applyDecoratedDescriptor as _applyDecoratedDescriptor } from "\0rollupPluginModLoBabelHelpers.js";
import { initializerWarningHelper as _initializerWarningHelper } from "\0rollupPluginModLoBabelHelpers.js";

var _dec, _class, _class2, _descriptor, _temp;

import { cclegacy as _cclegacy } from "cc";

_cclegacy._RF.push({}, "5eddalYFp9F4IwxRguvpiL0", "ActLoading", undefined);

// Learn TypeScript:
//  - https://docs.cocos.com/creator/manual/en/scripting/typescript.html
// Learn Attribute:
//  - https://docs.cocos.com/creator/manual/en/scripting/reference/attributes.html
// Learn life-cycle callbacks:
//  - https://docs.cocos.com/creator/manual/en/scripting/life-cycle-callbacks.html
import { _decorator, Component, Label } from "cc";
var ccclass = _decorator.ccclass,
    property = _decorator.property,
    menu = _decorator.menu;
var ActLoading = (_dec = menu("act/ActLoading"), ccclass(_class = _dec(_class = (_class2 = (_temp = /*#__PURE__*/function (_Component) {
  _inheritsLoose(ActLoading, _Component);

  function ActLoading() {
    var _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _Component.call.apply(_Component, [this].concat(args)) || this;

    _initializerDefineProperty(_assertThisInitialized(_this), "str", _descriptor, _assertThisInitialized(_this));

    _defineProperty(_assertThisInitialized(_this), "_t", 10);

    _defineProperty(_assertThisInitialized(_this), "_index", 0);

    _defineProperty(_assertThisInitialized(_this), "_lbl", null);

    return _this;
  }

  var _proto = ActLoading.prototype;

  // onLoad () {}
  _proto.start = function start() {
    this._lbl = this.node.getComponent(Label);
  };

  _proto.update = function update(dt) {
    if (this._t > 0) {
      this._t--;
    } else {
      this._t = 10;

      if (this._index == 0) {
        this._lbl.string = this.str + ".";
        this._index++;
      } else if (this._index == 1) {
        this._lbl.string = this.str + "..";
        this._index++;
      } else if (this._index == 2) {
        this._lbl.string = this.str + "...";
        this._index = 0;
      }
    }
  };

  return ActLoading;
}(Component), _temp), (_descriptor = _applyDecoratedDescriptor(_class2.prototype, "str", [property], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return "";
  }
})), _class2)) || _class) || _class);
export { ActLoading as default };

_cclegacy._RF.pop();